import * as React from 'react';

import { FormField } from 'components/form';
import SearchableDropdown from 'components/inputs/searchable-dropdown/SearchableDropdown';

import { useThunkDispatch } from 'hooks/use-thunk-dispatch';

import { __t, applyTranslations } from 'utils/language';
import { isArrayRequired } from 'utils/validators';
import { wrappedCitySearchToDropdownItems } from 'utils/locations';
import { mapGeoLocationToMixedDropdown } from '../../utils';

import './profile-location.scss';

applyTranslations(require('./profile-location.i18n.json'));

import type {
  InfluencerProfileForm,
  MixedSelectDropdownItem
} from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const MSG_KEY = 'profile_location';

const ProfileLocation: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const dispatch = useThunkDispatch();
  const locations = profile.locations ?? [];

  const handleChange = (
    updatedLocations: Array<MixedSelectDropdownItem>
  ): void => {
    const newLocations = updatedLocations
      .filter(item => item.isSelected)
      .map(({ data = {} }) => ({
        city: data.city,
        country: data.country,
        countryCode: data.countryCode,
        state: data.state
      }));

    onChange({
      locations: newLocations
    });
  };

  return (
    <div className="profile-location">
      <FormField
        label={__t(`${MSG_KEY}.labels.location`)}
        labelType="highlighted"
        direction="column"
        showRequiredMark
        showValidationIcon={false}
        className="profile-location__field"
        validators={[
          isArrayRequired(profile.locations)
        ]}
      >
        <SearchableDropdown
          key={JSON.stringify(locations)}
          items={locations.map(mapGeoLocationToMixedDropdown)}
          dataFetcher={wrappedCitySearchToDropdownItems(dispatch)}
          placeholder={__t(`${MSG_KEY}.placeholders.location`)}
          onItemsUpdate={handleChange}
        />
      </FormField>
    </div>
  );
};

export default ProfileLocation;
